import ko from "knockout";
import metaCache from "flow/utils/metaCache";

class TextMetaViewModel {
    text: string;

    constructor(componentInfo: KnockoutComponentTypes.ComponentInfo) {
        this.text = undefined;
        if (componentInfo.templateNodes.length > 0) {
            const node = componentInfo.templateNodes[0];
            if (node.nodeType === 3) {
                // text
                this.text = metaCache.translate((node as Text).data);
            }
        }
    }
}

ko.components.register("ko-meta", {
    viewModel: {
        createViewModel: (_params: any, componentInfo: KnockoutComponentTypes.ComponentInfo) => {
            return new TextMetaViewModel(componentInfo);
        }
    },
    template: "{{text}}",
    synchronous: true
});
